// extracted by mini-css-extract-plugin
export default {"layout":"loginPage_layout__5Rf0g","form":"loginPage_form__xUGtV","links":"loginPage_links__ODtCN","center":"loginPage_center__5jOS5"};